<div class="container">
  <div class="row">
    <button
      type="button"
      class="btn btn-default add-button"
      (click)="openEditModal(null)"
    >
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="courses && courses.length > 0">
    <table class="table table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Name</th>
        <th class="text-center" scope="col">Start Date</th>
        <th class="text-center" scope="col">End Date</th>
        <th class="text-center" scope="col">Lessons count</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let course of courses | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: pageNumber,
                    totalItems: totalElements
                  };
            let i = index">
        <td class="text-center">{{ course.id }}</td>
        <td class="text-center">{{ course.name }}</td>
        <td class="text-center">{{ course.startDate }}</td>
        <td class="text-center">{{ course.endDate }}</td>
        <td class="text-center">{{ course.lessonSchedules.length }}</td>
        <td class="text-center">
          <button
            type="button"
            class="btn btn-light edit-button"
            (click)="openEditModal(course)"
          >
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button
            type="button"
            class="btn btn-danger delete-button"
            (click)="openDeleteConfirmModal(course)"
          >
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="totalElements > 0" class="row justify-content-center">
    <div class="col-md-auto">
      <pagination-controls
        previousLabel="Prev"
        nextLabel="Next"
        responsive="true"
        (pageChange)="handlePageChange($event)"
      ></pagination-controls>
    </div>
    <div class="col-md-auto">
      Items per page:
      <select (change)="handlePageSizeChange($event)">
        <option *ngFor="let size of pageSizes" [ngValue]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="col-md-auto">
      <div>
        {{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items
      </div>
    </div>
  </div>
</div>
